import { Component, OnInit, Input } from '@angular/core';
import { ResultAlertError } from '@app/enums/errors.enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
  Componente que muestra un modal de errores personalizable.
  Este componente permite mostrar un mensaje de error con un título, código, UUID y otros detalles.
  También permite personalizar el estilo del modal, los botones y las imágenes.
**/
@Component({
  selector: 'app-errors-modal',
  templateUrl: './errors-modal.component.html',
  styleUrls: ['./errors-modal.component.scss'],
  standalone: false,
})
export class ErrorsModalComponent implements OnInit {
  /**
    Título del error que se muestra en el modal.
    @type {string}
  **/
  @Input() public titleError = '';

  /**
      Mensaje de error que se muestra en el modal.
      @type {string}
    **/
  @Input() public msgError = '';

  /**
      Código del error que se muestra en el modal.
      @type {string}
    **/
  @Input() public codeError = '';

  /**
      UUID del error que se muestra en el modal.
      @type {string}
    **/
  @Input() public uuidError = '';

  /**
      Texto que se muestra en la tarjeta de error (si es aplicable).
      @type {string}
    **/
  @Input() public printCard = '';

  /**
      Color de fondo del modal.
      @type {string}
      @default 'am-blue-premium'
    **/
  @Input() public backgroundColorModal = 'am-blue-premium';

  /**
      Indica si se debe mostrar el botón de acción.
      @type {boolean}
      @default true
    **/
  @Input() public showButton = true;

  /**
      Texto que se muestra en el botón de acción.
      @type {string}
    **/
  @Input() public buttonCopy = '';

  /**
      Indica si se debe mostrar un ícono o imagen en el modal.
      @type {boolean}
      @default true
    **/
  @Input() public showIconImage = true;

  /**
      Ruta de la imagen o ícono que se muestra en el modal.
      @type {string}
    **/
  @Input() public urlIconImage = '';

    /**
      Clase CSS adicional para la imagen del botón.
      @type {string}
    **/
    @Input() public btnImgClass: string = '';

    /**
      Color del texto del botón de acción.
      @type {string}
    **/
  @Input() public colorFontButton = '';

  /**
      Color de fondo del botón de acción.
      @type {string}
    **/
  @Input() public backGroundButton = '';

  /**
      Tamaño del modal (ej. 'sm', 'lg', 'xl').
      @type {string}
    **/
  @Input() public sizeModal = '';

  /**
      Grosor de la fuente del título del error.
      @type {string}
    **/
  @Input() public fontWeightTitleError = '';

  /**
      Ruta de la imagen que se muestra en el modal.
      @type {string}
    **/
  @Input() public image = '';

  /**
      Activa el estilo compacto de imagen (modal-image-3: 106x110px, con margen superior).
      @type {boolean}
      @default false
    **/
  @Input() public isVerPass = false;

  /**
      Indica si se debe mostrar el botón de cancelar.
      @type {boolean}
      @default false
    **/
  @Input() public showCancelButton = false;

  /**
      Texto que se muestra en el botón de cancelar.
      @type {string}
    **/
  @Input() public cancelButtonText = '';
  /**
   Bandera la cual controla el mostrar boton de cerrar
   @type {boolean}
   **/
  @Input() public showClose = true;
  /**
   Bandera la cual controla el mostrar un padding mas grande
   @type {boolean}
   **/
  @Input() public shortPadding = false;

  constructor(private modalService: NgbActiveModal) {}

  ngOnInit(): void {}
  /**
    Maneja el evento de clic en el botón de acción.
    Cierra el modal y emite una operación de aceptación.
    @return void
  **/
  actionBtn() {
    this.modalService.close({ operation: ResultAlertError.ACCEPT });
  }
  /**
    Maneja el evento de clic en el botón de cancelar.
    Cierra el modal sin realizar ninguna acción.
    @return void
  **/
  actionBtnCancel() {
    this.modalService.close({ operation: ResultAlertError.CANCEL });
  }
}
